const ageGate = {
	show: function () {
		let displayAgeGate = true;
		const ageGateForm = document.querySelector('[data-form="age-gate"]');
		if (!ageGateForm) return;

		const rememberMeCheckbox = ageGateForm.querySelector('input[type="checkbox"]');
		const ageGateDeniedBtn = ageGateForm.querySelector('button');
		const ageGateResponse = document.querySelector('[data-el="age-gate-response"]');

		if (window.sessionStorage.getItem('age-gate')) {
			displayAgeGate = false;
		}

		if (window.localStorage.getItem('age-gate')) {
			const time = parseInt(window.localStorage.getItem('age-gate'));
			if (Solver.now < time) displayAgeGate = false;
		}

		if (!displayAgeGate) return;

		UIkit.modal('#age-gate').show();

		ageGateForm.addEventListener('submit', function (event) {
			event.preventDefault();

			window.sessionStorage.setItem('age-gate', 'bypass');

			if (rememberMeCheckbox.checked) {
				window.localStorage.setItem('age-gate', Solver.setDays(30));
			}

			UIkit.modal('#age-gate').hide();
		});

		ageGateDeniedBtn.addEventListener('click', function (event) {
			event.preventDefault();
			ageGateResponse.removeAttribute('hidden');
		});

		return displayAgeGate;
	},
	on: {
		hide: function (callback) {
			UIkit.util.on('#age-gate', 'hide', function (event) {
				if (callback) callback();
			});
		}
	}
};

const homePageNewsletterSignup = {
	show: function () {
		if (
			!window.localStorage.getItem('newsletter') &&
			document.querySelector('#home-page-newsletter-signup')
		) {
			UIkit.modal('#home-page-newsletter-signup').show();
		}

		if (window.localStorage.getItem('newsletter')) {
			const time = parseInt(window.localStorage.getItem('newsletter'));

			if (Solver.now > time) UIkit.modal('#home-page-newsletter-signup').show();
		}
	},
	on: {
		hide: function () {
			UIkit.util.on('#home-page-newsletter-signup', 'hide', function (event) {
				window.localStorage.setItem('newsletter', Solver.setDays());
			});
		}
	}
};

const ageGateIsShowing = ageGate.show();

if (ageGateIsShowing) {
	ageGate.on.hide(() => {
		setTimeout(() => {
			homePageNewsletterSignup.show();
		}, 3000);
	});
}

if (!ageGateIsShowing) {
	setTimeout(() => {
		homePageNewsletterSignup.show();
	}, 3000);
}

homePageNewsletterSignup.on.hide();
